import type { Player } from '../../../../shared/api/player.ts';

export function activePlayers(players: Player[]): Player[] {
  return players.filter((player) => player.active);
}
